import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface HelpFaqItem {
  id: string;
  question: string;
  answer: string;
  category: string;
  sort_order: number;
  published: boolean;
}

export function useHelpFaq(includeUnpublished = false) {
  const [items, setItems] = useState<HelpFaqItem[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    let query = supabase
      .from("help_faq")
      .select("*")
      .order("sort_order", { ascending: true });

    if (!includeUnpublished) {
      query = query.eq("published", true);
    }

    const { data, error } = await query;
    if (error) {
      console.error("Failed to load FAQ:", error);
      setItems([]);
    } else {
      setItems((data ?? []) as HelpFaqItem[]);
    }
    setLoading(false);
  }, [includeUnpublished]);

  useEffect(() => {
    load();
  }, [load]);

  return { items, loading, reload: load };
}
